/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiTracksMutationRequest, PostApiTracksMutationResponse, PostApiTracks400, PostApiTracks401, PostApiTracks403, PostApiTracks404, PostApiTracks500 } from "../../types/PostApiTracks.ts";
import { postApiTracksMutationResponseSchema, postApiTracksMutationRequestSchema } from "../../zod/TracksSchemas/postApiTracksSchema.ts";

function getPostApiTracksUrl() {
  const res = { method: 'POST', url: `/api/tracks` as const }  
  return res
}

/**
 * @summary Добавление трека
 * {@link /api/tracks}
 */
export async function postApiTracks({ data }: { data?: PostApiTracksMutationRequest }, config: Partial<RequestConfig<PostApiTracksMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiTracksMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiTracksMutationResponse, ResponseErrorConfig<PostApiTracks400 | PostApiTracks401 | PostApiTracks403 | PostApiTracks404 | PostApiTracks500>, PostApiTracksMutationRequest>({ method : "POST", url : getPostApiTracksUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiTracksMutationResponseSchema.parse(res.data)
}